import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { CategoryData, getExportingOptions } from '../utils/jsonDataProcessing';

interface KeywordWordCloudProps {
  categoryData: CategoryData;
}

const KeywordWordCloud: React.FC<KeywordWordCloudProps> = ({ categoryData }) => {
  const options = {
    chart: {
      height: '400px'
    },
    title: {
      text: ''
    },
    series: [{
      type: 'wordcloud',
      data: categoryData.wordFrequencies.slice(0, 20),
      name: 'Occurrences'
    }],
    ...getExportingOptions('Keyword Cloud')
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default KeywordWordCloud;
